import React, {useEffect, useState} from 'react';
import '../../styles/bootstrap.css';
import '../../styles/sweetalert2.css';
import '../../styles/common.css';
import '../../styles/layout.css';
import '../../styles/modal.css';
import {Link, useNavigate} from 'react-router-dom';
import {DashboardData, getDashboard} from "../../api/homeApi";
import {useMemberWallet} from "../../hooks/useMemberWallet";
import {isLoggedIn} from "../../utils/authUtils";
import BannerSwiper from '../../components/common/BannerSwiper';
import PopupSwiper from '../../components/common/PopupSwiper';
import {setComma} from "../../utils/format";
import {useReadNotPushAlarmCount} from "../../hooks/useReadNotPushAlarmCount";
import {isNullOrEmpty} from "../../utils/validation";


export default function Home() {
    const navigate = useNavigate();
    const {memberWalletInfo, loading, error, refetch} = useMemberWallet();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const {readNotCount} = useReadNotPushAlarmCount();

    const [dashboard, setDashboard] = useState<DashboardData>({
        totalCoordinator: 0,
        accumulatedReward: 0,
        totalJobPosting: 0,
        noticeContent: "",
        noticeCode : "",
        csCenterNumber:""
    });

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                const res = await getDashboard();
                setDashboard(res.data.data);
            } catch (error) {
                console.error('Failed to fetch dashboard:', error);
            }
        };
        fetchDashboard();
    }, []);

    const handleCall = () => {
        if (!dashboard?.csCenterNumber) return;
        window.location.href = `tel:${dashboard.csCenterNumber}`;
    };

    useEffect(() => {
        const checkLoginStatus = async () => {
            if (isLoggedIn()) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        };

        checkLoginStatus();
    }, []);

    const handleLogin = () => {
        navigate('/login');
    };

    const handleSignUp = () => {
        navigate('/signup/terms');
    };

    const handleNoticeDetail = () => {
        if(!isNullOrEmpty(dashboard.noticeCode)) {
            navigate('/desk/notice/' + dashboard.noticeCode);
        }
    };

    return (
        <>
            <PopupSwiper section="MAIN" />
            <header className="main-header">
                <div className="header-inner">
                    {isAuthenticated ? (
                        <Link to="/alarmList" className="alarmBtn"><span className="blind">알림내역</span><span
                            className="count">{readNotCount || 0}</span></Link>) : null}
                    <h1 className="logo"><a href="#"><span className="blind">로고</span></a></h1>
                </div>
            </header>
            <main className="container">


                {isAuthenticated ? (
                    <>
                        <section>
                            <div className="inner">
                                <div className="notice-bar" onClick={handleNoticeDetail}>
                                    <span className="label">공지</span>
                                    <span className="text">{dashboard.noticeContent==''?'새로운 공지가 없습니다.':dashboard.noticeContent}</span>
                                </div>
                            </div>
                        </section>
                        <section>
                            <div className="inner">
                                <div className="main-wallet">
                                    <span className="label">보유 금액</span>
                                    <span className="amount">
                                      {setComma(memberWalletInfo?.prepaidBalance ?? 0)}원
                                    </span>
                                    <Link to="/wallet/charge" className="charge-btn">충전하기</Link>
                                </div>
                            </div>
                        </section>
                    </>
                ) : (
                    /* 로그인 하지 않았을 때 - 로그인/회원가입 버튼 표시 */
                    <section className="tit-box-wrap">
                        <h2 className="headline">로그인을 해주세요</h2>
                        <p className="subtit">간병인 신청부터 일자리 찾기까지<br/>더 많은 서비스를 이용할 수 있습니다.</p>
                        <div className="form-btn mt15">
                            <button type="button" className="line-btn" onClick={handleLogin}>로그인</button>
                            <button type="button" className="submit-btn" onClick={handleSignUp}>회원가입</button>
                        </div>
                    </section>
                )}

           {/*     <section>
                    <div className="inner">
                        <div className="service-count">
                            <div className="left">
                                <h4 className="tit">누적 공고</h4>
                                <p className="count">{dashboard.totalJobPosting}건</p>

                            </div>
                            <div className="right">
                                <h4 className="tit">등록 돌보미 수</h4>
                                <p className="count">{dashboard.totalCoordinator}명</p>
                            </div>
                        </div>
                    </div>
                </section>*/}

                <section>
                    <div className="inner">
                        <ul className="quick-menu-list">
                            <li>
                                <Link to="/service/apply/care">
                                    <span className="ico"></span>
                                    <h4>간병인 신청</h4>
                                </Link>
                            </li>
                            <li>
                                <Link to="/service/apply/escort">
                                    <span className="ico"></span>
                                    <h4>병원동행 신청</h4>
                                </Link>
                            </li>
                            <li>
                                <Link to="/service/apply/housekeeping">
                                    <span className="ico"></span>
                                    <h4>가사돌봄 신청</h4>
                                </Link>
                            </li>
                            <li>
                                <Link to="/nearby/shop">
                                    <span className="ico"></span>
                                    <h4>내 주변</h4>
                                </Link>
                            </li>
                            <li>
                                <Link to="/task/findTask">
                                    <span className="ico find"></span>
                                    <h4>일자리 찾기</h4>
                                </Link>
                            </li>
                            <li>
                                <Link to="/menu/coordinator">
                                    <span className="ico coordi"></span>
                                    <h4>코디 신청</h4>
                                </Link>
                            </li>
                        </ul>

                    </div>
                </section>

                {/* 배너 영역 - 동적으로 로드 */}
                <BannerSwiper
                    section="MAIN"
                    autoplayDelay={3000}
                    loop={true}
                />

                <section>
                    <div className="inner-bottom">
                        <ul className="cs-menu">
                            <li>
                                <button onClick={handleCall}>
                                    <span>고객센터</span>
                                </button>
                            </li>
                            <li>
                                <Link to="/desk/faq">
                                    <span>자주묻는 질문</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </section>
            </main>
        </>
    );
}